import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { resolveAccessTokenForEndpoint } from "@Front/Api/helpers/authTokenResolutionHelpers";

/**
 * Resolves the access token for the API context inferred from endpoint.
 * Notary calls are strictly isolated from customer/third-party stores and cookies.
 */
export function getAccessTokenFromStores(endpoint?: string): string | null {
	const { context, token } = resolveAccessTokenForEndpoint(endpoint);
	if (!token && context === "notary") {
		LoggerService.warn("⚠️ [ApiAuthContext] Missing notary token for authenticated notary request", {
			endpoint: endpoint ?? null,
		});
	}
	return token;
}
